import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreErrorService } from "./services/store-error.service";

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [StoreErrorService]
})
export class StoreErrorModule {}
